import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, List, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { For } from 'react-loops';
import { useLeftNav } from '../../context';
import { appHeaderHeight, navMaxWidth, navMinWidth, topNavHeight, transitionSpeed } from '../../theme';
import { LeftNavItem } from './LeftNavItem';
import { ToggleButton } from './ToggleButton/ToggleButton';
const useStyles = makeStyles((theme) => ({
    containerPaper: {
        backgroundColor: theme.palette.brand.feather25,
        borderRight: `1px solid ${theme.palette.divider}`,
        height: `calc(100vh - (${appHeaderHeight}px + ${topNavHeight + 1}px))`,
        flex: `0 0 ${navMinWidth}px`,
        top: `calc(${appHeaderHeight}px + ${topNavHeight + 1}px)`,
        overflowX: 'hidden',
        padding: theme.spacing(1, 0, 0),
        position: 'sticky',
        transition: `width ${transitionSpeed} ease-out`,
        width: navMinWidth,
        zIndex: 100,
        [theme.breakpoints.up('sm')]: {
            flex: `0 0 ${navMaxWidth}px`,
            width: navMaxWidth,
        },
    },
    containerPaperCollapsed: {
        flex: `0 0 ${navMinWidth}px`,
        width: navMinWidth,
    },
    nav: {
        height: 'calc(100% - 50px)',
    },
    navContainer: {
        display: 'flex',
        flex: `0 0 ${navMaxWidth}px`,
        flexDirection: 'column',
        height: '100%',
        width: navMinWidth,
        [theme.breakpoints.up('sm')]: {
            flex: `0 0 ${navMaxWidth}px`,
            width: navMaxWidth,
        },
    },
    scrollContainer: {
        height: 'calc(100% - 50px)',
        overflow: 'hidden',
        overflowY: 'auto',
    },
    topContainer: {
        padding: theme.spacing(2),
    },
}));
/**
 * Left navigation component for AgentNet applications
 *
 * @param {LeftNavLink[]} links - An array of links to be displayed in the left navigation.
 */
export function LeftNav({ componentTop, links }) {
    const classes = useStyles();
    const { isOpen, setIsOpen } = useLeftNav();
    const toggleNavigation = () => {
        setIsOpen(!isOpen);
    };
    const createId = (str) => {
        return str.split(' ').join('-').toLowerCase();
    };
    const showShowStatusIcon = ({ subLinks }) => {
        if (subLinks) {
            return subLinks.some((subLink) => subLink.status !== undefined);
        }
        return false;
    };
    return (_jsxs("div", { className: clsx(classes.containerPaper, { [classes.containerPaperCollapsed]: !isOpen }), "data-testid": 'left-nav', children: [_jsx("div", { className: classes.scrollContainer, children: _jsxs("div", { className: classes.navContainer, children: [componentTop && (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.topContainer, children: componentTop }), _jsx(Divider, {})] })), _jsx("nav", { className: classes.nav, children: _jsx(List, { disablePadding: true, children: _jsx(For, { of: links, as: (link) => (_jsx(LeftNavItem, { ...link, id: createId(link.text), isMenuOpen: isOpen, shouldShowDot: showShowStatusIcon(link) })) }) }) })] }) }), _jsx(ToggleButton, { isMenuOpen: isOpen, onClick: toggleNavigation })] }));
}
